import { useEffect, useState } from "react";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import {
  useNavigate,
  NavigationType,
  useNavigationType,
} from "react-router-dom";
import { FaCalendarAlt, FaCocktail, FaUmbrella } from "react-icons/fa";
import { FaHotel } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./Slide.css";
import { MainTemplate } from "templates/MainTemplate";
import { ReactComponent as LeftIcon } from "../../images/leftIcon.svg";
import Cookies from "js-cookie";
import { fetchPlans } from "services/fetch-plans";
import { Plan } from "./type";
import { useMetadataHotel } from "contexts/metadata-hotel-context";

const PageSubcription = () => {
  const [plans, setPlans] = useState<Plan[]>([]);
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const isActive: string | undefined = Cookies.get("active_user");
  const {
    setPlanId,
    setPlanName,
    setPoints,
    setDescription,
    setMonthlyValue
  } = useMetadataHotel();

  const redirectToPayment = (plan: Plan) => {
    setPlanId(plan.id)
    setPlanName(plan.name)
    setPoints(plan.points)
    setDescription(plan.description)
    setMonthlyValue(plan.monthly_value)

  
    navigate("/checkout", {
      state: {
        planDetails: {
          id: plan.id,
          name: plan.name,
          points: plan.points,
          monthly_value: plan.monthly_value,
          total_value: plan.monthly_value * 12,
        },
      },
    });
  };

  const renderPricingItem = (plan: Plan) => {
    return (
      <SwiperSlide className="flex justify-center rounded-xl p-2" key={plan.id}>
        <div className="flex h-[450px] flex-col border justify-between items-center py-6 bg-white rounded-lg shadow-lg dark:bg-neutral-800">
          <div>
            <h3 className="text-center text-2xl mb-4">{plan.name}</h3>
            <h2 className="flex items-center justify-center text-6xl font-bold">
              <span className="text-sm">R$</span>
              <span className="font-semibold text-6xl">
                {plan.monthly_value
                  .toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })
                  .replace(".", ",")
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
                  .replace(",00", "")}
              </span>
              <span className="text-lg ml-1 font-normal text-neutral-500">
                /mês
              </span>
            </h2>
          </div>
          <nav>
            <ul>
              {plan.description.split(";").map((item, index) => {
                let icon;

                if (item.includes("diárias")) {
                  icon = <FaCalendarAlt className="mr-2" />;
                } else if (item.includes("Hotéis")) {
                  icon = <FaHotel className="mr-2" />;
                } else if (item.includes("Resorts")) {
                  icon = <FaUmbrella className="mr-2" />;
                } else if (item.includes("Inclusive")) {
                  icon = <FaCocktail className="mr-2" />;
                } else {
                  icon = <FaHotel className="mr-2" />;
                }

                return (
                  <li
                    className="flex items-center justify-center"
                    key={`${item.length}`}
                  >
                    <span className="text-primary-6000">{icon}</span>
                    <span className="text-neutral-700 text-lg dark:text-neutral-300">
                      {item.trim()}
                    </span>
                  </li>
                );
              })}
            </ul>
          </nav>
          <div className="w-full flex justify-center items-center">
            <ButtonSecondary
              className="w-10/12 bg-gray-200 text-gray-800 dark:bg-primary-6000"
              onClick={() => redirectToPayment(plan)}
            >
              <span className="font-medium">Assinar</span>
            </ButtonSecondary>
          </div>
        </div>
      </SwiperSlide>
    );
  };

  useEffect(() => {
    const verifySignatureUser = async () => {
      if (isActive === "1" && navigationType === NavigationType.Pop) {
        return navigate("/home");
      }

      try {
        const plans = await fetchPlans();
        setPlans(plans.data.sort((a: Plan, b: Plan) => a.monthly_value - b.monthly_value));
      } catch (error) {
        setPlans([]);
      }
    };

    verifySignatureUser();
  }, []);

  return (
    <MainTemplate>
      <section className="container">
        <button
          className="cursor-pointer relative z-10 top-5 left-5 hidden lg:flex items-center"
          onClick={() => navigate(-1)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              navigate(-1);
            }
          }}
        >
          <LeftIcon style={{ marginRight: "10px" }} />
          <span className="text-xl">Voltar</span>
        </button>
        <div className="flex flex-col justify-center items-center">
          <header className="flex flex-col justify-center items-center">
            <h2 className="text-3xl font-bold text-center mt-4">
              Planos flexíveis para você
            </h2>
            <span className="text-lg text-center mt-2">
              Valores que os colaboradores pagam por mês.*
            </span>
          </header>
          {plans.length === 0 && (
            <div className="flex justify-center items-center min-h-[calc(100svh-420px)]">
              <span className="text-2xl">Carregando...</span>
            </div>
          )}
          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            spaceBetween={`${window.innerWidth < 768 ? 15 : 30}`}
            slidesPerView={window.innerWidth < 768 ? 1 : 3}
            navigation
            pagination={{ clickable: true }}
            className="p-8 m-12 h-full w-full flex justify-center items-center"
          >
            {plans.length > 0 &&
              plans.map((plan, index) => renderPricingItem(plan))}
          </Swiper>
        </div>
      </section>
    </MainTemplate>
  );
};

export default PageSubcription;
